import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppConfigService } from '../../services/app-config.service';

@Pipe({
    name: 'orgDate',
    pure: false
})
export class OrgDatePipe implements PipeTransform {
    constructor(private configService: AppConfigService, private datePipe: DatePipe) {}

    transform(value: any, type: 'date' | 'dateTime' = 'date'): string | null {
        if (!value) return null;

        try {
            const formats = this.configService.get('formats');
            let formatString = 'dd/MM/yyyy'; // Default fallback

            if (type === 'dateTime') {
                formatString = (formats && formats.dateTime) ? formats.dateTime : 'dd/MM/yyyy HH:mm';
            } else {
                formatString = (formats && formats.date) ? formats.date : 'dd/MM/yyyy';
            }

            return this.datePipe.transform(value, formatString);
        } catch (e) {
            // Fallback if config fails
            return this.datePipe.transform(value, 'dd/MM/yyyy');
        }
    }
}
